import { em } from 'polished'
import styled from 'styled-components'

export const Box = styled.div`
  display: flex;
  justify-content: stretch;
`

export const BoxCode = styled.div`
  width: ${em(100)};
  margin-right: ${em(20)};
`

export const BoxPhone = styled.div`
  flex-grow: 1;
`
